import { render } from "./SFormElementCO2.vue?vue&type=template&id=045e22a5&scoped=true"
import script from "./SFormElementCO2.vue?vue&type=script&lang=js"
export * from "./SFormElementCO2.vue?vue&type=script&lang=js"

import "./SFormElementCO2.vue?vue&type=style&index=0&id=045e22a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045e22a5"]])

export default __exports__